import React from "react";
import { useApp } from "@/context/AppContext";

export const PARTNER_AIRLINES = [
  { code: "IA", ar: "الخطوط الجوية العراقية", en: "Iraqi Airways" },
  { code: "TK", ar: "الخطوط التركية", en: "Turkish Airlines" },
  { code: "QR", ar: "الخطوط القطرية", en: "Qatar Airways" },
  { code: "MS", ar: "مصر للطيران", en: "EgyptAir" },
  { code: "RJ", ar: "الملكية الأردنية", en: "Royal Jordanian" },
  { code: "G9", ar: "العربية للطيران", en: "Air Arabia" },
  { code: "FZ", ar: "فلاي دبي", en: "flydubai" },
  { code: "IR", ar: "الخطوط الإيرانية", en: "Iran Air" },
  { code: "EK", ar: "طيران الإمارات", en: "Emirates" },
  { code: "6Q", ar: "أجنحة الشام", en: "Cham Wings" },
  { code: "WY", ar: "الطيران العُماني", en: "Oman Air" },
  { code: "ME", ar: "طيران الشرق الأوسط", en: "Middle East Airlines" },
  { code: "W5", ar: "ماهان", en: "Mahan Air" },
  { code: "UD", ar: "يو آر – البصرة", en: "UR Airlines" },
  { code: "ZV", ar: "زاكروس", en: "Zagros Airlines" },
];

export const AirlineLogos = () => {
  const { t, lang } = useApp();
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-12" data-testid="airline-logos">
      <div className="text-center mb-6">
        <h2 className="text-base md:text-lg font-bold text-slate-700">{t.flights.partnersTitle}</h2>
        <p className="text-xs text-slate-400 mt-1">{t.flights.partnersSub}</p>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
        {PARTNER_AIRLINES.map((a) => (
          <div key={a.code} data-testid={`airline-logo-${a.code}`} title={a[lang]}
            className="bg-white rounded-2xl border border-slate-100 shadow-sm h-24 flex flex-col items-center justify-center gap-1.5 px-3 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <img src={`https://pics.avs.io/240/90/${a.code}.png`} alt={a[lang]} loading="lazy" className="h-9 sm:h-10 w-auto max-w-[85%] object-contain" />
            <span className="text-[10px] sm:text-[11px] text-slate-500 font-semibold text-center leading-tight truncate w-full">{a[lang]}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
